module.exports = __webpack_public_path__ + "static/media/know-time-delete.0d035f8b.png";